import React, { Component } from 'react'
import './home.css'

export default class Home extends Component {
  render() {
    return <div className='home'>欢迎使用后台管理系统</div>
  }
}
